import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { LifeDelay } from "./LifeDelay";
import { LifeDuration } from "./LifeDuration";
export var Life = /*#__PURE__*/function () {
  function Life() {
    _classCallCheck(this, Life);
    this.count = 0;
    this.delay = new LifeDelay();
    this.duration = new LifeDuration();
  }
  _createClass(Life, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.count !== undefined) {
        this.count = data.count;
      }
      this.delay.load(data.delay);
      this.duration.load(data.duration);
    }
  }]);
  return Life;
}();